var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top_list weekList",on:{"click":_vm.clickVisible}},[_c('div',{staticClass:"list_text"},[_c('i'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.currentTime))]),_vm._v(" "),_c('i',{staticClass:"iconfont"},[_vm._v("")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-787db6c2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/components/mixins/listTimeShow.vue
// module id = null
// module chunks = 